var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import axiosRetry from 'axios-retry';
import domains from 'global';
var axiosMockClient = axios.create({
    baseURL: domains.url,
    timeout: 120000,
});
export var axiosAuthClient = axios.create({
    baseURL: "".concat(domains.auth, "/api"),
    timeout: 60000,
});
axiosMockClient.interceptors.request.use(
// @ts-ignore
function (config) {
    var accessToken = window.sessionStorage.getItem('auth_token');
    if (!accessToken)
        return config;
    return (__assign(__assign({}, config), { headers: __assign(__assign({}, config.headers), { Authorization: "Bearer ".concat(accessToken), Accept: 'application/json' }) }));
}, function (error) { return Promise.reject(error); });
var verifyRefreshToken = function (originalRequest, axiosResponse) { return __awaiter(void 0, void 0, void 0, function () {
    var refreshToken, data, err_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                refreshToken = window.localStorage.getItem('auth_refresh');
                if (!refreshToken) return [3 /*break*/, 6];
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 5]);
                return [4 /*yield*/, axiosAuthClient.post('/auth/refresh_token', { refresh_token: refreshToken })];
            case 2:
                data = (_b.sent()).data;
                window.sessionStorage.setItem('auth_token', data.data.token);
                window.localStorage.setItem('auth_refresh', data.data.refresh_token);
                axios.defaults.headers.common.Authorization = "Bearer ".concat(data.token);
                return [4 /*yield*/, axiosMockClient(originalRequest)];
            case 3: return [2 /*return*/, _b.sent()];
            case 4:
                err_1 = _b.sent();
                document.location.assign("".concat(domains.auth, "?redirect=").concat(window.location.href));
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, Promise.reject(new Error((_a = axiosResponse.data) === null || _a === void 0 ? void 0 : _a.msg))];
            case 6:
                /* no refresh token, user need to log in */
                document.location.assign("".concat(domains.auth, "?redirect=").concat(window.location.href));
                return [2 /*return*/, null];
        }
    });
}); };
var handleResponse = function (axiosResponse) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                originalRequest = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.config;
                if (!(((_a = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _a === void 0 ? void 0 : _a.status) === 'KO' && ((_b = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _b === void 0 ? void 0 : _b.code) === '401'
                    && !originalRequest._retry)) return [3 /*break*/, 2];
                originalRequest._retry = true;
                return [4 /*yield*/, verifyRefreshToken(originalRequest, axiosResponse)];
            case 1:
                _c.sent();
                _c.label = 2;
            case 2: return [2 /*return*/, axiosResponse];
        }
    });
}); };
var handleError = function (axiosError) { return __awaiter(void 0, void 0, void 0, function () {
    var originalRequest;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                originalRequest = (_a = axiosError.response) === null || _a === void 0 ? void 0 : _a.config;
                if (!(((_b = axiosError.response) === null || _b === void 0 ? void 0 : _b.status) === 401 && !originalRequest._retry)) return [3 /*break*/, 2];
                originalRequest._retry = true;
                return [4 /*yield*/, verifyRefreshToken(originalRequest, axiosError.response)];
            case 1:
                _c.sent();
                _c.label = 2;
            case 2: return [2 /*return*/, Promise.reject(axiosError)];
        }
    });
}); };
axiosMockClient.interceptors.response.use(handleResponse, function (error) { return handleError(error); });
axiosMockClient.interceptors.response.use(handleResponse, function (error) { return handleError(error); });
axiosRetry(axiosMockClient, {
    retries: 2,
    shouldResetTimeout: true,
    retryCondition: function (error) {
        var isTimeout = error.code === 'ECONNABORTED';
        var isServerError = error.response && error.response.status >= 500 || false;
        return isTimeout || isServerError;
    },
    retryDelay: function (retryCount) { return retryCount * 1000; },
});
export default axiosMockClient;
